<template>
  <div class="teacher">
    <div class="teacher__header">
      <h1 class="teacher__title">Teacher Portal</h1>
    </div>
  </div>
</template>

<script>
import { firestore } from "@/services/firebase";
import SACFrontendService from "@/services/SACFrontendService";
import { addDuration, getWeek } from "vue-chess-shared/utils/date-helper";

export default {
  name: "TeacherHome",

  components: {},

  data() {
    return {};
  },

  watch: {},

  computed: {},

  methods: {
    async syncLectures() {
      const { teacherId } = SACFrontendService.teacherInfo();
      const newLectures = await SACFrontendService.getLecturesByTeacherId(
        teacherId,
        new Date(2024, 0, 1),
        addDuration(new Date(), 12, "month")
      );

      const lecturesRef = firestore.collection("lectures");
      const existingLectures = (await lecturesRef.get()).docs.map((doc) => {
        return {
          id: doc.id,
          ...doc.data(),
        };
      });

      const batch = firestore.batch();

      // delete those no longer returned from SAC
      const toBeDeleted = existingLectures.filter(
        (l) =>
          teacherId === l.teacherId &&
          !newLectures.find((nl) => nl.cdid === l.id)
      );
      toBeDeleted.forEach((l) => {
        const lectureRef = lecturesRef.doc(l.id);
        batch.delete(lectureRef);
      });

      // add or update those are returned from SAC

      newLectures.forEach((l) => {
        const lectureRef = lecturesRef.doc(l.cdid);
        const startTime = new Date(Number(l.startTime) * 1000);
        const endTime = new Date(Number(l.endTime) * 1000);
        const lectureDate = new Date(Number(l.date) * 1000);
        const lectureEndDate = new Date(Number(l.date) * 1000);

        lectureDate.setHours(startTime.getHours());
        lectureDate.setMinutes(startTime.getMinutes());
        lectureDate.setSeconds(startTime.getSeconds());

        lectureEndDate.setHours(endTime.getHours());
        lectureEndDate.setMinutes(endTime.getMinutes());
        lectureEndDate.setSeconds(endTime.getSeconds());

        batch.set(
          lectureRef,
          {
            cdid: l.cdid,
            year: Number(l.year),
            term: Number(l.term),
            day: Number(l.day),
            classroomId: l.classId,
            createdAt: new Date(),
            updatedAt: new Date(),
            lectureDate: lectureDate,
            lectureEndDate: lectureEndDate,
            status: "Created",
            teacherId: l.coachId,
            firstName: l.firstName,
            lastName: l.lastName,
            weekNumber: getWeek(lectureDate),
            title: l.topicsCovered,
          },
          { merge: true }
        );
      });

      // commit the batch
      await batch.commit();

      console.log(
        `Successfully deleted ${toBeDeleted.length} lectures, and then create/update ${newLectures.length} lectures`
      );
    },
  },

  async created() {
    const isAuth = await SACFrontendService.checkAuth();
    if (!isAuth) {
      this.$router.replace({ name: "TeacherLogin" });
      return;
    }
    await this.syncLectures();
  },
};
</script>

<style scoped>
.teacher {
  width: 100%;
  padding: 2rem;
  margin: 0 auto;
}

.teacher__header {
  margin-bottom: 2rem;
}

.teacher__title {
  font-size: 1.5rem;
  font-weight: bold;
}
</style>
